import { DELIVERY_CHALLAN_REQUEST, CREATE_DELIVERY_CHALLAN, GET_DELIVERY_CHALLANS, UPDATE_DELIVERY_CHALLAN, DELETE_DELIVERY_CHALLAN,
    DELIVERY_CHALLAN_REQUEST_FAILURE, GET_DELIVERY_CHALLAN_PAGE, DELIVERY_CHALLAN_REQUEST_SUCCESS, GET_LAST_FIVE_DELIVERY_CHALLANS
} from '../types';

const initialState = {
  deliveryChallans: [],
  deliveryChallansPage: [],
  lastFiveDeliveryChallans: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const deliveryChallanReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELIVERY_CHALLAN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DELIVERY_CHALLANS: {
      return {
        ...state,
        deliveryChallans: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_LAST_FIVE_DELIVERY_CHALLANS: {
      return {
        ...state,
        lastFiveDeliveryChallans: [...action.payload],
        loading: false,
        error: null
      }
    }
    case DELIVERY_CHALLAN_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case GET_DELIVERY_CHALLAN_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        deliveryChallansPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_DELIVERY_CHALLAN:
      return {
        ...state,
        deliveryChallans: [action.payload, ...state.deliveryChallans],
        loading: false,
        error: null
      };
    case UPDATE_DELIVERY_CHALLAN:
      const deliveryChallansData = state.deliveryChallans.slice(0);
      const uIndex = deliveryChallansData.findIndex((data) => data.id === action.payload.id);
      deliveryChallansData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        deliveryChallans: [ ...deliveryChallansData ],
        loading: false,
        error: null
      };
    case DELETE_DELIVERY_CHALLAN:
      const deliveryChallans = state.deliveryChallans?.slice(0);
      const index = deliveryChallans.findIndex((data) => data.id === action.id);
      if (index > -1) {
        deliveryChallans.splice(index, 1);
      }
      return {
        ...state,
        deliveryChallans: [...deliveryChallans],
        loading: false,
        error: null
      }
    case DELIVERY_CHALLAN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default deliveryChallanReducer;
